module.exports = __webpack_public_path__ + "static/media/7.3de5b888.jpg";